import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Document} from '../../../models/browseDocuments.model';
import {animate, animateChild, query, stagger, style, transition, trigger} from '@angular/animations';
import {DocTypeToken, FileService} from '../../../_services/api/file.service';
import {MatDialog} from '@angular/material/dialog';
import {LoadingDialogComponent} from '../../shared/loading-dialog/loading-dialog.component';
import {saveAs} from 'file-saver';
import {ProcessingStatus} from '../../../models/processingStatus.model';
import {WebSocketSubject} from 'rxjs/webSocket';
// import {ANONYMIZATION_STATUS_WEBSOCKET} from '../../../_services/constants';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FileUploader} from 'ng2-file-upload';
import {Router} from '@angular/router';
import {HttpEvent, HttpEventType} from '@angular/common/http';

@Component({
  selector: 'app-anonymization-status',
  templateUrl: './anonymization-status.component.html',
  styleUrls: ['./anonymization-status.component.scss'],
  animations: [
    trigger('fileList', [
      transition( ':enter', [
        query( '@fileItem',
          stagger(50, animateChild()), { optional: true })
      ])
    ]),
    trigger( 'fileItem', [
      transition( ':enter', [
        style({opacity: 0, transform: 'translateY(-50%)'}),
        animate('500ms 0.1s cubic-bezier(0.35, 0, 0.25, 1)')
      ])
    ])
  ]

})
export class AnonymizationStatusComponent implements OnInit {
  @Input() documents: Document[];
  @Output() deletedItem = new EventEmitter<Document>();
  @Output() downloadAll = new EventEmitter<any>();

  @Input() uploader: FileUploader;
  @Input() uploadingFileStatus: any;

  processingStatus: ProcessingStatus;
  anonymizationStatusWebSocket: WebSocketSubject<any>;
  downloadableDocuments = true;
  waitingForAnonymization = true;

  constructor(private fileService: FileService, private dialog: MatDialog, private _snackBar: MatSnackBar,
              private cdr: ChangeDetectorRef, private router: Router) { }

  ngOnInit(): void {
    this.processingStatus = {
      running: true, title: 'Warning',
      message: 'Some of your files are still being anonymized. Do you want to leave the page and stop the anonymization process?',
      confirm: 'Leave', dismiss: 'Stay'
    };

    const webSocketError = {
      max_retires: '3 retries exceeded',
      cant_process_entity_type: 'when job can\'t detect what is the type of file based on file headers',
      cant_upload: 'can\'t upload file back to the backend',
      unexpected_error: 'something went wrong'
    };

  }


  download(): void {

      const anonymizedNonZip = this.documents.filter(x => x.extension !== 'ZIP');

      if (anonymizedNonZip.length > 0) {
        const confirmDialog = this.dialog.open(LoadingDialogComponent, {
          data: {
            loaderType: 'file-packing',
            label: 'Preparing your files', status: 0
          }, disableClose: true
        });

        const docIds: DocTypeToken[] = [];
        anonymizedNonZip.forEach(
          doc => {
            const index = docIds.findIndex(x => x.type === doc.type);
            if (index >= 0) {
              docIds[index].tokens.push(doc.docId);
            } else {
              docIds.push({tokens: [doc.docId], type: doc.type});
            }
          }
        );
        const queueId = Math.random().toString(36).slice(2, 7);

        this.fileService.download(docIds, queueId).subscribe((event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.DownloadProgress:
                confirmDialog.componentInstance.data.status = (event.loaded / event.total) * 100;
                break;
              case HttpEventType.Response:
                const response = event.body;
                const blob = new Blob([response], {
                  type: response.type
                });
                let filename = '';
                if (response.type === 'application/x-zip-compressed') {
                  filename = this.fileService.getFileName();
                } else {
                  const doc = this.documents.filter(item => item.docId === docIds[0].tokens[0]);
                  filename = doc[0].name;
                }
                saveAs(blob, filename);
                confirmDialog.close();
            }
          }, error => {
            confirmDialog.close();
          },
          () => {
            confirmDialog.close();
          });
      }

      if (this.documents.length - anonymizedNonZip.length > 0){
        this.downloadAll.emit();
      }

  }

  showDocument(doc: Document) {
    if (doc.progress === 100) {
      if (doc.type === 'image') {
        this.router.navigate(['/image', doc.docId]);
      } else if (doc.type === 'video') {
        this.router.navigate(['/video', doc.docId]);
      } else if (doc.type === 'text') {
        this.router.navigate(['/document', doc.docId]);
      }
    } else {
      this._snackBar.open('Document not ready.', 'close', {
        duration: 2000,
      });
    }
  }

}
